import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { TrackedLink } from '@xingternal/xing-tracking';
import { Link } from '@xingternal/link';

import styles from './Footer.css';

const LinkList = ({ data = [], className, external }) => {
  const FooterLink = external ? Link : TrackedLink;
  return (
    <ul className={cx(styles.items, className)}>
      {data.map((link) => (
        <li key={link.key} className={styles.item}>
          <FooterLink
            className={styles.itemLink}
            to={link.href}
            {...(external ? {} : { trackingKey: link.key || 'footer' })}
          >
            <FormattedMessage id={link.title} />
          </FooterLink>
        </li>
      ))}
    </ul>
  );
};

LinkList.defaults = {
  external: false,
};

LinkList.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  external: PropTypes.bool,
};

export { LinkList };
